import * as Msal from '@azure/msal-browser';

export default class AuthService {
    constructor() {
        const msalConfig = {
            auth: {
                clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
                redirectUri: process.env.VUE_APP_MICROSOFT_REDIRECT_URI,
                //postLogoutRedirectUri: process.env.VUE_APP_MICROSOFT_REDIRECT_URI,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: 'localStorage',
            },
        };
        this.app = new Msal.PublicClientApplication(msalConfig);
    }
    login() {
        return this.app.loginPopup(['user.read']).then((data) => {
            if (data.idToken) return data.idToken;
        });
    }
    logout() {
        this.app.logout();
    }
}
